import React from "react";

import CoachSelector from "app/components/CoachSelector";
import { CoachProfileModel } from "app/models/scheduling/CoachProfileModel";

import CoachSettingsButton from "./CoachSettingsButton";
import styles from "./styles.module.scss";

type PropsDef = {
  coaches: CoachProfileModel[];
  selectedCoachId: string | null;
  onChange: (coachId: string) => void;
  onSettingsClick?: (coachId: string, event: React.MouseEvent) => void;
};

/**
 * The header of the coach column in the Resources view.
 *
 * The selector is the one the settings pages use, so a user picks a coach here
 * in the same way. The gear button opens the settings of the chosen coach.
 */
export default function CompareCoachHeader({
  coaches,
  selectedCoachId,
  onChange,
  onSettingsClick,
}: PropsDef) {
  return (
    <div
      className={styles.compare_coach_header}
      data-testid="compare-coach-header"
    >
      <CoachSelector
        coaches={coaches}
        value={selectedCoachId}
        onChange={onChange}
        menuPortalTarget={document.body}
        classNamePrefix="rs"
      />
      {onSettingsClick && selectedCoachId && (
        <CoachSettingsButton
          coachId={selectedCoachId}
          onClick={onSettingsClick}
        />
      )}
    </div>
  );
}
